export default __webpack_public_path__ + "static/media/Abhishek.06caa53c.jpg";